import * as z from "zod/v4";
import { CompensationMethod } from "../../../return";
import { makeReportFilterSchema } from "./base-report-filter";
import { ReportFilterType } from "./report-filter-type";

export enum CompensationMethodsFilterQuery {
  INCLUDES_ANY = "includesAny",
  INCLUDES_ALL = "includesAll",
  INCLUDES_NONE = "includesNone",
}

const CompensationMethodsFilterSchema_ = makeReportFilterSchema(
  ReportFilterType.COMPENSATION_METHODS,
  CompensationMethodsFilterQuery,
  z.array(z.enum(CompensationMethod)),
);
export const CompensationMethodsFilterSchema: z.ZodType<CompensationMethodsFilter> =
  CompensationMethodsFilterSchema_;
export interface CompensationMethodsFilter
  extends z.infer<typeof CompensationMethodsFilterSchema_> {}
